var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CHATBOT_INJECT_SUCCESS, CHATBOT_INIT_SUCCESS, CHATBOT_UPDATE_ATTRIBUTES, CHATBOT_ADD_LOOKUP_NAMES, CHATBOT_ADD_ATTRIBUTES, CHATBOT_OPEN_SUCCESS, CHATBOT_CLOSE_CONVERSATION, CHATBOT_INJECT, CHATBOT_LOG_INTAKE_ERROR, CHATBOT_LOG_INTAKE_SUCCESS } from "../action";
var initialState = {
    status: undefined,
    rescueSubmitted: false,
    isOpen: false,
    attributes: {},
    lookupName: undefined,
    intakeLog: {
        status: undefined,
        result: undefined,
    }
};
export default function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case CHATBOT_INJECT:
            return __assign(__assign({}, state), { rescueSubmitted: action.payload.rescueSubmitted });
        case CHATBOT_INJECT_SUCCESS:
            return __assign(__assign({}, state), { status: "INJECTED" });
        case CHATBOT_INIT_SUCCESS:
            return __assign(__assign({}, state), { status: "INITIALIZED" });
        case CHATBOT_ADD_LOOKUP_NAMES:
            return __assign(__assign({}, state), { lookupName: action.payload });
        case CHATBOT_ADD_ATTRIBUTES:
            return __assign(__assign({}, state), { attributes: action.payload });
        case CHATBOT_UPDATE_ATTRIBUTES:
            return __assign(__assign({}, state), { attributes: __assign(__assign({}, state.attributes), action.payload) });
        case CHATBOT_OPEN_SUCCESS:
            return __assign(__assign({}, state), { isOpen: true });
        case CHATBOT_CLOSE_CONVERSATION:
            return __assign(__assign({}, state), { isOpen: false });
        case CHATBOT_LOG_INTAKE_ERROR:
            return __assign(__assign({}, state), { intakeLog: {
                    status: "error",
                    result: action.payload,
                } });
        case CHATBOT_LOG_INTAKE_SUCCESS:
            return __assign(__assign({}, state), { intakeLog: {
                    status: "success",
                    result: action.payload,
                } });
        default:
            return state;
    }
}
